import { Theme } from '@mui/material';
import darkTheme from '@shared/themes/darkTheme';

/*
Buttons for each row
*/

export const ButtonStyle = ((theme: Theme) => {
  return {
    color: theme.palette.action.active,
    flexGrow: 1,
    transition: 'all 0.1s ease',
    pointerEvents: 'all',
    cursor: 'pointer',
    ':hover': {
      color: theme.palette.action.hover,
    },
  };
})(darkTheme);

export const DisabledButtonStyle = (theme: Theme) => {
  return {
    ...ButtonStyle,
    color: theme.palette.action.disabled,
    cursor: 'default',
    ':hover': {},
  };
};

export const ListIconButtonStyle = (theme: Theme) => {
  return {
    color: theme.palette.action.active,
    transition: 'all 0.1s ease',
    pointerEvents: 'all',
    opacity: 0.5,
    cursor: 'pointer',
    ':hover': {
      opacity: 1,
    },
    minWidth: 0,
  };
};

export const ListIconButtonStyleNoHover = (theme: Theme) => {
  return { ...ListIconButtonStyle(theme), ':hover': { opacity: 0.5 }, cursor: 'default' };
};

export const CellRendererStyle: React.CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  alignContent: 'center',
  justifyContent: 'justify',
  padding: 0,
  margin: 0,
  whiteSpace: 'nowrap',
};

// TODO: there's some slightly odd typescript behaviour with `makeStyles` which means that we can't
// export a hook returning this. Need to investigate if there's a particular signature required
// that will allow us to extract this properly

export const popupBackgroundClasses = {
  menuPaper: {
    maxHeight: '12em',
  },
};

export const FooterPopupGroupStyle: React.CSSProperties = {
  display: 'block',
  position: 'absolute',
  bottom: '10px',
  width: '2rem',
  height: '2rem',
};

const OptionalPriceStyle: React.CSSProperties = {
  fontSize: '0.8em',
  fontWeight: 'bold',
  width: 'auto',
};

export const TextStyles = {
  bid: { ...OptionalPriceStyle, color: darkTheme.palette.background.buy },
  ask: { ...OptionalPriceStyle, color: darkTheme.palette.background.sell },
};
